import React, { useEffect } from "react";
import api from "../api";
import { NavLink } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";

const Headder = props => {
  useEffect(() => {

    let x = document.getElementsByClassName("nav-link");
    for (let index = 0; index < x.length; index++) {
      // console.log(x[index].href);
      if (x[index].href.indexOf("/deviceView") > 0) {
        x[index].id = "DVID";
      } else if (x[index].href.indexOf("/deviceControl") > 0) {
        x[index].id = "DCID";
      } else if (x[index].href.indexOf("/userMng") > 0) {
        x[index].id = "UMID";
      } 
    }
  }, [props.client]);

  return (
    <React.Fragment>
      <Navbar bg="dark" variant="dark" expand="md" sticky="top">
        {/* expand="lg" */}
        <Navbar.Brand>
          <NavLink to={"/"}>Home</NavLink>
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse>
          <Nav className="mr-auto">
            {props.client !== 0 && (
              <Nav.Item>
                <Nav.Link as={NavLink} to="/deviceView">
                  Device View
                </Nav.Link>
              </Nav.Item>
            )}
            {props.client !== 0 && (
              <Nav.Item>
                <Nav.Link as={NavLink} to="/deviceControl">
                  Device Control
                </Nav.Link>
              </Nav.Item>
            )}
            {props.userMng === 1 && (
              <Nav.Item>
                <Nav.Link as={NavLink} to="/userMng">
                  Managment
                </Nav.Link>
              </Nav.Item>
            )}
            {props.client === 0 && (
              <Nav.Item>
                <Nav.Link as={NavLink} to="/Login">
                  Login
                </Nav.Link>
              </Nav.Item>
            )}
            {props.client === 1 && (
              <Nav.Item>
                <Nav.Link as={NavLink} to="/DeviceSetup">
                  Device Setup
                </Nav.Link>
              </Nav.Item>
            )}
            {/* {props.client !== 0 && (
            <Nav.Item>
              <Nav.Link as={NavLink} to="/ResolvesInfo">
                Help
              </Nav.Link>
            </Nav.Item>
            )} */}
            <Nav.Item>
              <Nav.Link as={NavLink} to="/contact">
                Contact
              </Nav.Link>
            </Nav.Item>
            {/* {props.uid === 1 && (
              <Nav.Item>
                <Nav.Link as={NavLink} to="/System">
                  System
                </Nav.Link>
              </Nav.Item>
            )} */}
          </Nav>

          {props.client !== 0 && (
            <Nav>
            <Nav.Item>
              <Nav.Link as={NavLink} to="/profile">
                Profile
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link onClick={props.handleLogout} as={NavLink} to="/Login">
                Log Out
              </Nav.Link>
            </Nav.Item>
            </Nav>
          )}
          <NavDropdown title="Language" id="basic-nav-dropdown">
            <NavDropdown.Item as={NavLink} to="/contact">
              English
            </NavDropdown.Item>
            {/*
            <NavDropdown.Item as={NavLink} to="/contact">
              Hebrew
            </NavDropdown.Item>
            <NavDropdown.Item as={NavLink} to="/contact">
              Espaniol
            </NavDropdown.Item>
            */}
          </NavDropdown>
        </Navbar.Collapse>
      </Navbar>
      {/* {props.userName && (
          <div> Logged is as: {props.userName}</div>
        )} */}
      {/* <NetworkDetector /> */}
    </React.Fragment>
  );
};

export default Headder;
